module.exports = __webpack_public_path__ + "static/media/startpage_ergotherapie-soest.a5649e5c.jpg";